import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { formFieldsSelector, selectShortcutSelector } from '../../../store/selectors/editForm';
import { contributeFormSelector } from '../../../store/selectors/form';
import { setFocusedField } from '../../../store/actions/editForm';
import {
  GPSCOORDINATES,
  PHONENUMBER,
  ADVANCEDSELECT,
  MCQ,
} from '../../../constants/typology/fieldType';

function getSelector(fieldId, field) {
  switch (field.type) {
    case PHONENUMBER:
      return `[name$="${fieldId}"] > input`;

    case GPSCOORDINATES:
      return `[name$="${fieldId}.latitude"]`;

    case ADVANCEDSELECT:
      return `[id$="${fieldId}"] input[id^="react-select-"]`;

    case MCQ:
      return `[name$="${fieldId}_MCQ_0"]`;
  }

  return `[name$="${fieldId}"]`;
}

function ShortcutKeyboard() {
  const dispatch = useDispatch();

  const fields = useSelector(formFieldsSelector);
  const contribute = useSelector(contributeFormSelector);
  const keyMap = useSelector(selectShortcutSelector);
  const keys = Object.keys(keyMap);

  const handleShortcurt = (key, e) => {
    const field = fields.find((field) => {
      if (field.id === keyMap[key]) return field.id;
    });

    if (contribute) {
      const selector = getSelector(field.id, field);
      const element = document.querySelector(selector);

      if (element != null) {
        element.focus();
      }
    } else dispatch(setFocusedField(field.id));
    e.preventDefault();
  };
  useEffect(() => {
    const handler = (e) => {
      if (!e.shiftKey) return;
      const key = `shift+${e.key.toLowerCase()}`;
      if (keys.includes(key)) {
        handleShortcurt(key, e);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [keys, handleShortcurt]);

  return null;
}

export default ShortcutKeyboard;
